import { Col, Row } from "react-bootstrap";
import React from "react";
import { useSelector } from "react-redux";

import "./home.scss";
import SunburstChart from "./Chart/SunburstChart";
import ResultKnowledge from "./Result/KnowledgeResult";
import GoalResult from "./Result/GoalResult";
import ImpactResult from "./Result/ImpactResult";
import NewKnowledgeResult from "./Result/NewKnowledgeResult";

import KnowledgeBottom from "./Result/ResultBottom/KnowledgeBottom";
import GoalBottom from "./Result/ResultBottom/GoalBottom";
import ImpactBottom from "./Result/ResultBottom/ImpactBottom";

export default function Knowledge(props) {
  const DataChart = useSelector((state) => state.statehome.knowledgeChart);
  const {
    title,
    page,
    campusName,
    KnowledgeName,
    impactName,
    goalName,
    campus,
    Knowledge,
    impact,
    goal,
  } = props;

  const innovationsResult = useSelector(
    (state) => state.statehome.innovationsResult
  );
  const newknowledgeResult = useSelector(
    (state) => state.statehome.newknowledgeResult
  );
  const knowledgeResult = useSelector(
    (state) => state.statehome.knowledgeResult
  );

  const bcgResult = useSelector((state) => state.statehome.bcgResult);
  const sdgResult = useSelector((state) => state.statehome.sdgResult);
  const curveResult = useSelector((state) => state.statehome.curveResult);
  const clusterResult = useSelector((state) => state.statehome.clusterResult);

  const economyResult = useSelector((state) => state.statehome.economyResult);
  const socialResult = useSelector((state) => state.statehome.socialResult);
  const culturalResult = useSelector((state) => state.statehome.culturalResult);
  const environmentResult = useSelector(
    (state) => state.statehome.environmentResult
  );

  const resultOne = useSelector((state) => state.statehome.resultOne);

  console.log("knowledgeChart", DataChart);

  console.log("knowledgeResult", knowledgeResult);
  console.log("innovationsResult", innovationsResult);

  console.log("newknowledgeResult", newknowledgeResult);

  console.log("campusName :", campusName);
  console.log("KnowledgeName : ", KnowledgeName);
  console.log("impactName : ", impactName);
  console.log("goalName : ", goalName);
  console.log("page : ", page);

  console.log("resultOne", resultOne);

  return (
    <div className="detail-home">
      <h5>{title}</h5>
      <Row>
        <Col sm={12} md={12} lg={6} xl={5} xxl={5} className="div-chart">
          {DataChart.length > 4 ? (
            <SunburstChart
              page={page}
              university={campus}
              knowledge={Knowledge}
              impact={impact}
              goal={goal}
            />
          ) : (
            <>
              <h5 style={{ textAlign: "center" }}>ไม่พบข้อมูล</h5>
            </>
          )}
        </Col>
        <Col
          sm={12}
          md={12}
          lg={6}
          xl={7}
          xxl={7}
          style={{ marginTop: "1rem" }}
        >
          <h5>
            ผลการค้นหา : {campusName !== "" ? `${campusName} ` : null}
            {KnowledgeName !== "" ? ` / ${KnowledgeName}` : null}
            {impactName !== "" ? ` / ${impactName}` : null}
            {goalName !== "" ? ` / ${goalName}` : null} (
            {page === "knowledge" ? (
              <>
                {knowledgeResult.length +
                  newknowledgeResult.length +
                  innovationsResult.length}
              </>
            ) : page === "goal" ? (
              <>
                {bcgResult.length +
                  sdgResult.length +
                  curveResult.length +
                  clusterResult.length}
              </>
            ) : page === "impact" ? (
              <>
                {economyResult.length +
                  socialResult.length +
                  culturalResult.length +
                  environmentResult.length}
              </>
            ) : page === "newknowledge" ? (
              <>{newknowledgeResult.length + innovationsResult.length}</>
            ) : null}
            )
          </h5>

          {resultOne.length ? (
            <div
              className="card-university"
              style={{
                backgroundColor: "#fff",
                borderRadius: "15px",
              }}
            >
              {page === "knowledge" ? (
                <>
                  <div className="card-header">
                    <h5>{resultOne[0].label}</h5>
                    <p>จำนวน {resultOne.length}</p>
                  </div>
                  <div className="card-university-body">
                    <div className="list" style={{ height: "500px" }}>
                      {resultOne.map((data, index) => (
                        <div className="detail" key={index}>
                          <h5>{data.title}</h5>
                          <p>
                            รายละเอียด :{" "}
                            {data.detail
                              ? data.detail.replace(
                                  /<[^>]+>|&nbsp;|&quot;/g,
                                  ""
                                )
                              : null}
                          </p>
                          <hr className="line-researcher" />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : page === "goal" ? (
                <>
                  <div className="card-header">
                    <h5>
                      {resultOne[0].groupname === "bcg"
                        ? "BCG"
                        : resultOne[0].groupname === "sdg"
                        ? "SDGs"
                        : resultOne[0].groupname === "curve"
                        ? "10S-Curve"
                        : resultOne[0].groupname === "cluster"
                        ? "RMUTI Cluster"
                        : null}
                    </h5>
                    <p>จำนวน {resultOne.length}</p>
                  </div>
                  <div className="card-university-body">
                    <div className="list" style={{ height: "500px" }}>
                      {resultOne.map((data, index) => (
                        <div className="detail" key={index}>
                          <h6>
                            <b>โครงการวิจัย : </b>{" "}
                            {data.concept_proposal_name_th}
                          </h6>
                          <h6>
                            <b>ปัจจัย :</b>{" "}
                            {data.bcg_name
                              ? data.bcg_name
                              : data.cluster_name
                              ? data.cluster_name
                              : data.curve_name
                              ? data.curve_name
                              : data.sdgs_name
                              ? data.sdgs_name
                              : null}
                          </h6>
                          <hr className="line-researcher" />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : page === "impact" ? (
                <>
                  <div className="card-header">
                    <h5>{resultOne[0].name}</h5>
                    <p>จำนวน {resultOne.length}</p>
                  </div>
                  <div className="card-university-body">
                    <div className="list" style={{ height: "500px" }}>
                      {resultOne.map((data, index) => (
                        <div className="detail" key={index}>
                          <h6>
                            <b>โครงการวิจัย : </b>{" "}
                            {data.concept_proposal_name_th}
                          </h6>
                          <h6>
                            <b>ปัจจัย :</b> {data.factor_name}
                          </h6>
                          <h6>
                            <b>ประเด็น :</b>{" "}
                            {data.issue_detail.map((rw, i) => (
                              <>
                                {i + 1}
                                {"."}
                                {rw.issue_detail}{" "}
                              </>
                            ))}
                          </h6>
                          <hr className="line-researcher" />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : page === "newknowledge" ? (
                <>
                  <div className="card-header">
                    <h5>{resultOne[0].label}</h5>
                    <p>จำนวน {resultOne.length}</p>
                  </div>
                  <div className="card-university-body">
                    <div className="list" style={{ height: "500px" }}>
                      {resultOne.map((data, index) => (
                        <div className="detail" key={index}>
                          <h5>{data.title}</h5>
                          <p>
                            รายละเอียด :{" "}
                            {data.detail
                              ? data.detail.replace(
                                  /<[^>]+>|&nbsp;|&quot;/g,
                                  ""
                                )
                              : null}
                          </p>
                          <hr className="line-researcher" />
                        </div>
                      ))}
                    </div>
                  </div>
                </>
              ) : null}
            </div>
          ) : (
            <>
              {page === "knowledge" ? (
                <>
                  {knowledgeResult.length || innovationsResult.length ? (
                    <ResultKnowledge />
                  ) : (
                    <KnowledgeBottom />
                  )}
                </>
              ) : page === "goal" ? (
                <>
                  {bcgResult.length || sdgResult.length ? (
                    <GoalResult />
                  ) : (
                    <GoalBottom col={[12, 12, 12]} />
                  )}
                </>
              ) : page === "impact" ? (
                <>
                  {economyResult.length || socialResult.length ? (
                    <ImpactResult />
                  ) : (
                    <ImpactBottom  col={[12, 12, 12]}/>
                  )}
                </>
              ) : page === "newknowledge" ? (
                <NewKnowledgeResult />
              ) : null}
            </>
          )}
        </Col>

        {resultOne.length ? null : (
          <>
            {page === "knowledge" ? (
              <>
                {knowledgeResult.length && innovationsResult.length ? (
                  <KnowledgeBottom />
                ) : null}
              </>
            ) : page === "goal" ? (
              <>
                {bcgResult.length && sdgResult.length ? (
                  <GoalBottom col={[5, 6, 7]} />
                ) : null}
              </>
            ) : page === "impact" ? (
              <>
                {economyResult.length && socialResult.length ? (
                  <ImpactBottom  col={[5, 6, 7]}/>
                ) : null}
              </>
            ) : null}
          </>
        )}
      </Row>
    </div>
  );
}
